import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { InfoFieldRow } from '../../../store/models/info-field.model';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { InfoFieldItemComponent } from '../info-field-item/info-field-item.component';

@Component({
  selector: 'ui-info-field-list',
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    InfoFieldItemComponent,
  ],
  templateUrl: './info-field-list.component.html',
  styleUrls: ['./info-field-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InfoFieldListComponent {
  @Input() title: string;
  @Input() rows: InfoFieldRow[];
  @Input() flat = false;
}
